<template>
  <div style="padding-bottom:5px;">
    <div style="padding-bottom:2px;cursor:pointer" @click="triggerHide">
      <label style="padding-right:10px;padding-bottom:5px;display:inline">{{ $t('orderLine.extras') }}</label>
      <svg-icon :hidden="!hide" :size="1.5" icon-class="arrow-right" />
      <svg-icon :hidden="hide" :size="1.5" icon-class="arrow-down" />
    </div>
    <div :hidden="hide">
      <el-table ref="extrasTable" :data="extras" row-key="id" border fit>
        <el-table-column :label="$t('common.finish')" prop="code">
          <template slot-scope="scope">
            <Select
              v-model="scope.row['finishID']"
              :options="extraFinishesAvailableFiltered"
              :placeholder="$t('common.finish')"
              value-field="finishID"
              label-field="description"
              type="select"
              @input="handleFinishChange(scope.row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('orderLine.measurement')" prop="name" width="90px">
          <template slot-scope="scope">
            <MDinput
              v-if="scope.row && scope.row.measurementRequiredYN"
              v-model="scope.row['measurementInCm']"
              type="number"
              style="width:90%;"
              suffix="cm"
              :precision="0"
              @input="emitValues"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.product')" prop="name">
          <template slot-scope="scope">
            <Select
              v-if="scope.row && scope.row.requiredProductTypeID"
              v-model="scope.row['productID']"
              style="padding-right:2px"
              :options="products.filter(p => p.productTypeID === scope.row.requiredProductTypeID)"
              value-field="id"
              label-field="description"
              class="search-select"
              @input="emitValues"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';
import Select from '@/components/DSE/Select';
import MDinput from '@/components/MDinput';

export default {
  name: 'ExtrasTable',
  components: {
    SvgIcon,
    Select,
    MDinput
  },
  props: {
    extraFinishesAvailable: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: true,
      errorMsg: '',
      extras: [{}],
      hide: false
    };
  },
  computed: {
    products() {
      return this.$store.getters['product/loadedItems'];
    },
    extraFinishesAvailableFiltered() {
      const finishIDsAlreadyChosen = this.extras.filter(e => e.finishID).map(e => e.finishID);
      return this.extraFinishesAvailable.filter(f => !finishIDsAlreadyChosen.includes(f.finishID));
    },
    finishTypes() {
      return this.$store.getters['finishType/loadedItems'];
    }
  },
  watch: {},
  created() {
    this.loading = false;
  },
  methods: {
    emitValues() {
      this.$emit(
        'input',
        this.extras.filter(e => e.finishID)
      );
    },
    triggerHide() {
      this.hide = !this.hide;
    },
    handleFinishChange(row, finishID) {
      row.measurementInCm = undefined;
      row.productID = undefined;
      row.amount = undefined;
      if (finishID) {
        const finishSelected = this.extraFinishesAvailable.find(f => f.finishID === finishID);
        const correspondingFinishType = this.finishTypes.find(ft => ft.id === finishSelected.finishTypeID);
        row.measurementRequiredYN = correspondingFinishType.measurementRequiredYN;
        row.requiredProductTypeID = correspondingFinishType.requiredProductTypeID;
        if (this.extras.every(r => r.finishID)) {
          this.extras.push({});
        }
      } else {
        row.measurementRequiredYN = undefined;
        row.requiredProductTypeID = undefined;
      }
      this.emitValues();
    },
    formatUnitOption(unitOption) {
      const option = this.$store.getters['option/loadedOptions']('capacityUnit').find(item => item.code === unitOption);
      return option && option.description;
    }
  }
};
</script>
